import { useMutation, useQueryClient } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { ApiError } from "./useGetAllApplications";

const jsonHeaders = {
    "Content-Type": "application/ld+json",
    Accept: "application/ld+json",
};

type DeleteWebhookOptions = {
    applicationId: string;
    webhookId: string;
};

export const useDeleteWebhook = () => {
    const queryClient = useQueryClient();

    const mutation = useMutation<void, ApiError, DeleteWebhookOptions>(
        async (options: DeleteWebhookOptions) => {
            const { applicationId, webhookId } = options;

            await loggedInApiCall.delete(`/api/integrations/applications/${applicationId}/webhooks/${webhookId}`, {
                headers: jsonHeaders,
            });
        },
        {
            onSuccess: (_, { applicationId }) => {
                queryClient.invalidateQueries(["applicationWebhooks", applicationId]);
            },
        },
    );

    return mutation;
};
